import { connect } from 'react-redux';
import { handleError } from 'services/ErrorService/ErrorService';
import { setShowTools as showToolsAction } from '../actions/index';
import { handleEscalationPopup } from '../actions/popupActions';
import ConversationComponent from '../components/ConversationComponent/ConversationComponent';
import {
  extractCurrentQueueLength,
  extractSelectedTicketFromState,
  isSelectedTicketReviewTicket,
} from '../extractFromState';

function mapStateToProps(state) {
  return {
    isAdmin: (state.user && state.user.isAdmin) || false,
    selectedInboxTab: state.ui.messages.selectedInboxTab,
    general: (state.ui && state.ui.tools && state.ui.tools.general) || {},
    queueLength: extractCurrentQueueLength(state),
    selectedTicket: extractSelectedTicketFromState(state),
    reviewTicketSelected: isSelectedTicketReviewTicket(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setShowTools(showTools) {
      return dispatch(showToolsAction(showTools));
    },
    async handleEscalationPopup(ticket) {
      try {
        await dispatch(handleEscalationPopup(ticket));
      } catch (error) {
        handleError({ error });
      }
    },
  };
};

const ConversationContainer = connect(mapStateToProps, mapDispatchToProps)(ConversationComponent);

export default ConversationContainer;
